import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import './style.css'

function Link(props) {
  let className = 'link-wrapper'
  const to = props.to || ''

  className = props.underlined || false ? className + ' underlined' : className

  return (
    <div className={className} cypress_id={props.cypress_id}>
      <RouterLink to={to}>{props.text}</RouterLink>
    </div>
  )
}

export default Link
